import {PureComponent} from 'react'
import {Link} from 'react-router-dom'

import DefaultLayout from '../Layout/DefaultLayout.jsx'
import Header from '../../components/Header/Header.jsx'

import {generate} from '../../routes.js'

import lawyer from './images/lawyer.jpg?size=600'

import './Legal.scss'

export default class Legal extends PureComponent {
  render() {
    const title = 'Faire appel aux consultants : réglementation et risques'
    const description = 'Toutes nos réponses à vos questions et craintes concernant les délits de prêt de main d\'œuvre illicite, de marchandage & autres enjeux juridiques'

    return <DefaultLayout id="legal" showSidebarMenu={false} helmet={{title, description}}>
      <Header title={title}/>
      <section className="container py-5">
        <h2 className="text-center mb-3">
          Les plateformes d'intermédiation doivent-elles craindre les délits de prêt de main d'œuvre illicite et de
          marchandage ?
        </h2>
        <p>
          En mettant en relation des experts indépendants en quête de missions professionnelles et des entreprises
          clientes, les plateformes d'intermédiation constituent des places de marché attractives.
        </p>
        <h2 className="text-center mb-3">
          Mais sont-elles à l'abri des délits de prêt de main d'œuvre illicite et de marchandage ?
        </h2>
        <p>
          Par définition, le prêt de main d'œuvre illicite est caractérisé par « toute opération à but lucratif ayant
          pour objet exclusif le prêt de main d'œuvre » (Code du travail, article L. 8241-1).
        </p>
        <p>
          De son côté, le marchandage est défini comme « toute opération à but lucratif de fourniture de main d'œuvre
          qui a pour effet de causer un préjudice au salarie qu'elle concerne ou d'éluder l'application de
          dispositions légales ou de stipulations d'une convention ou d'un accord collectif de travail » (Code du
          travail, article L 8231-1).
        </p>
        <p>
          <strong>Seuls les employeurs sont concernés par ces textes</strong>. Ce qui est illicite est de prêter des
          salariés pour s'enrichir. Or, les plateformes d'intermédiation, qui ne recrutent pas de salariés mais se
          contentent de réunir des prestataires indépendants et des entreprises sur un marché donne, <strong>ne sont
          donc pas considérés comme des employeurs</strong> et sont par conséquent à l'abri de ces risques pénaux.
        </p>
        <p>
          Cependant, il existe un risque pénal si le prestataire indépendant est lie par un contrat de travail avec la
          plateforme, car dans ce cas il est placé dans un « lien de subordination juridique » à son égard (ce qui
          n'est pas le cas pour Twineeds).
        </p>
        <p>
          Cette situation est peu probable lorsque la plateforme joue un simple rôle d'intermédiation.
        </p>
        <p>
          C'est pourquoi, le risque pénal de prêt de main d'œuvre ou de délit de marchandage est équivalent que
          l'entreprise fasse appel à une plateforme comme Twineeds ou bien qu'<strong>elle ait directement recours a
          un consultant salarié ou indépendant</strong>.
        </p>
      </section>
      <div className="bg-light">
        <section className="container py-5">
          <div className="row align-items-center">
            <div className="col-12 col-lg-8">
              <h2 className="mb-4">Un besoin à traiter, un poste à pourvoir ?<br/>Faites confiance à Twineeds !</h2>
              <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Déposer un besoin</Link>
            </div>
            <div className="col-lg-4 d-lg-block d-none">
              <a href="https://www.linkedin.com/in/arthur-lampert-baa49882/" target="_blank" rel="noopener noreferrer">
                <figure className="bg-white p-3 mx-auto">
                  <img className="mb-2" src={lawyer.src} alt="Arthur Lampert, avocat en droit social"/>
                  <figcaption className="text-center">
                    <p className="font-weight-bold mb-0 text-secondary">Arthur Lampert</p>
                    <p className="text-secondary mb-0">avocat en droit social</p>
                  </figcaption>
                </figure>
              </a>
            </div>
          </div>
        </section>
      </div>
    </DefaultLayout>
  }
}